import React, {  useEffect, useState } from 'react'
import PropTypes from 'prop-types'

const Checkbox = ({label,name,checked,onChange,className,disabled}) => {
  const [checkedState, setChecked] = useState(false)

  const checkProps = () => setChecked(checked)

  useEffect(() => {
    checkProps()
  }, [])

  useEffect(() => {
      if(checked !== checkedState) checkProps()
  }, [checked])

  const handleChange = () => {
    const check = !checkedState
    setChecked(check)

    typeof(onChange) === 'function' && onChange(check)
  }

  return (
    <>
      <label
        className={`checkbox-label ${checkedState ? 'on' : ''} ${className || ''}`}
      >
        <input
          type='checkbox'
          className='checkbox-input'
          name={name}
          disabled={disabled}
          onChange={handleChange}
        />
        <span className='checkmark' />
        <span
          className={`check-square ${
            !(checkedState === -1 || checkedState === null) && 'hide'
          }`}
        />
        <span className='checkbox-label-text'>{label}</span>
      </label>
    </>
  )

}
  Checkbox.propTypes = {
    /* The text that will be displayed along with the checkbox */
    label: PropTypes.string.isRequired,

    /* The checkbox name */
    name: PropTypes.string.isRequired,

    /* The checkbox checked parameter */
    checked: PropTypes.bool,

    /* The checkbox change callback */
    onChange: PropTypes.func,

    /* custom class */
    className: PropTypes.string,

    disabled: PropTypes.bool,
  }

export default Checkbox
